import { render } from "./settings-modal.vue?vue&type=template&id=e06b68e2&scoped=true"
import script from "./settings-modal.vue?vue&type=script&lang=js"
export * from "./settings-modal.vue?vue&type=script&lang=js"

import "./settings-modal.vue?vue&type=style&index=0&id=e06b68e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06b68e2"]])

export default __exports__